import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 1a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0zm0 19.234a1 1 0 1 0-2 0V23a1 1 0 1 0 2 0zM4.719 12a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h2.719a1 1 0 0 1 1 1M23 13a1 1 0 1 0 0-2h-2.719a1 1 0 0 0 0 2zM3.339 21.95a1 1 0 0 1 0-1.415l2.016-2.016a1 1 0 0 1 1.415 1.414l-2.017 2.016a1 1 0 0 1-1.414 0ZM20.661 3.73a1 1 0 0 0-1.414-1.414L17.23 4.333a1 1 0 0 0 1.415 1.414L20.66 3.73ZM3.339 2.317a1 1 0 0 0 0 1.415l2.016 2.016A1 1 0 1 0 6.77 4.333L4.753 2.316a1 1 0 0 0-1.414 0ZM20.661 20.27a1 1 0 0 1-1.414 1.415l-2.017-2.017a1 1 0 0 1 1.415-1.414zM11.103 4.537c.138-.275.418-.594.897-.594s.758.32.896.594l1.76 3.52 3.364.336c.307.03.652.186.824.566.191.42.05.842-.218 1.11l-2.803 2.803 1.041 3.814a.97.97 0 0 1-.278.994.97.97 0 0 1-1.105.141L12 16.08l-3.452 1.728c-.31.154-.754.21-1.125-.118-.362-.32-.357-.746-.276-1.043l1.03-3.776-2.79-2.79c-.225-.226-.414-.59-.271-1.024.148-.452.538-.634.874-.668l3.353-.336z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceFavoriteStarsShining = { render };
export {
  interfaceFavoriteStarsShining as default,
  render
};
//# sourceMappingURL=interface-favorite-stars-shining.svg.js.map
